import { MODAL_TYPES } from 'Constants/modal';
import { addModal, removeModal } from 'Redux/modules/modal/actions';
import { getLatestCert } from 'Redux/modules/webChat/actions';
import { useDispatch } from 'react-redux';

const useIssueMC = conversation => {
  const consultId = conversation?.latestConsult?.id;

  const dispatch = useDispatch();

  const openToIssueMC = async mcModalType => {
    dispatch(removeModal(mcModalType));
    dispatch(
      addModal({
        type: mcModalType,
        id: mcModalType,
        data: {
          conversation,
          onClose: () => {
            dispatch(removeModal(mcModalType));
            dispatch(removeModal(MODAL_TYPES.CREATE_MC));
          },
        },
      }),
    );
  };

  // Check if there is an existing MaNaDr Medical Certificate in this consult
  const openToIssueManadrMC = async () => {
    const data = await dispatch(getLatestCert(consultId));
    if (!data?.data?.length) {
      openToIssueMC(MODAL_TYPES.MANADR_CERT);
    } else {
      const cert = data?.data[0];
      dispatch(
        addModal({
          type: 'confirmVoidMC',
          id: 3,
          data: {
            conversation,
            cert,
          },
        }),
      );
    }
  };

  const openToIssueDigiMC = async () => openToIssueMC(MODAL_TYPES.DIGI_MC);

  return {
    openToIssueManadrMC,
    openToIssueDigiMC,
  };
};

export default useIssueMC;
